// PageNavMenuItemTreeCheckBox
// ***********************************************************************************************************************
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IPageNavMenuItemTreeCheckBoxChildProp {
    isActive: boolean;
    item: IIdTitleNode;
    level: number;
    activeItemIds: string[];
    onToggleItem: (item: IIdTitleNode, checked: boolean, hasChildren: boolean) => void;
}

class PageNavMenuItemTreeCheckBoxChild extends React.Component<IPageNavMenuItemTreeCheckBoxChildProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        const hasChildren = item.hasChildren();
        const selected = props.activeItemIds.indexOf(item.id) > -1;
        if (props.isActive) {
            return (
                <Stack>
                    <FormControlLabel
                        label={item.title}
                        control={
                            <Checkbox
                                checked={selected}
                                disabled={!item.active}
                            />
                        }
                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); props.onToggleItem(item, !selected, hasChildren); }}
                        sx={{ paddingLeft: `${props.level.toString(10)}0px` }}
                    />
                    {item.children.map((childItem) =>
                        <PageNavMenuItemTreeCheckBoxChild
                            key={childItem.id}
                            isActive={true}
                            item={childItem}
                            level={props.level + 1}
                            activeItemIds={props.activeItemIds}
                            onToggleItem={props.onToggleItem}
                        />
                    )}
                </Stack>
            );
        }
        if (!selected) return null;
        return (
            <>
                <Typography sx={{ paddingLeft: `${props.level.toString(10)}0px` }}>
                    {item.title}
                </Typography>
                {item.children.map((childItem) =>
                    <PageNavMenuItemTreeCheckBoxChild
                        key={childItem.id}
                        isActive={false}
                        item={childItem}
                        level={props.level + 1}
                        activeItemIds={props.activeItemIds}
                        onToggleItem={props.onToggleItem}
                    />
                )}
            </>
        );
    }
}

export interface IPageNavMenuItemTreeCheckBoxProp {
    classes?: string;
    hidden?: boolean;
    isActive: boolean;
    items: IIdTitleNode[];
    activeItemIds: string[];
    title: string;
    onToggleMenuItem: () => void;
    onSetActiveItemIds: (ids: string[]) => void;
}

export class PageNavMenuItemTreeCheckBox extends React.Component<IPageNavMenuItemTreeCheckBoxProp, {}> {
    handleToggleItem = (item: IIdTitleNode, checked: boolean, hasChildren: boolean) => {
        if (!item || !item.active) return;
        const id = item.id;
        const props = this.props;
        let activeItemIds = props.activeItemIds.filter(i => i !== Base.emptyGuid);
        if (hasChildren) {
            const parent = IdTitleNode.getById(props.items, id);
            if (!parent) return;
            const childIds = parent.getChildIds();
            activeItemIds = activeItemIds.filter(i => childIds.indexOf(i) < 0 && i !== id);
            if (checked) {
                activeItemIds.push(id);
                activeItemIds = activeItemIds.concat(childIds);
            }
        } else {
            if (id === Base.emptyGuid) {
                if (checked) {
                    props.onSetActiveItemIds([Base.emptyGuid]);
                    return;
                } else if (activeItemIds.length < 1 && props.items.length > 1) {
                    activeItemIds.push(props.items[1].id);
                }
            } else {
                if (checked) {
                    if (activeItemIds.indexOf(id) < 0) {
                        activeItemIds.push(id);
                    }
                } else {
                    activeItemIds = activeItemIds.filter(i => i !== id);
                }
            }
        }
        if (activeItemIds.length < 1) {
            activeItemIds.push(Base.emptyGuid);
        }
        props.onSetActiveItemIds(activeItemIds);
    };

    render() {
        const props = this.props;
        if (props.hidden) return null;
        const items = props.items;
        return (
            <>
                <Accordion expanded={props.isActive}>
                    <AccordionSummary onClick={props.onToggleMenuItem} expandIcon={<ExpandMoreIcon />}>
                        {props.title}
                    </AccordionSummary>
                    <AccordionDetails>
                        {items &&
                            <Stack>
                                {items.map((item) => {
                                    const hasChildren = item.hasChildren();
                                    const selected = props.activeItemIds.indexOf(item.id) > -1;
                                    return <div key={item.id}>
                                        <FormControlLabel
                                            label={item.title}
                                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleToggleItem(item, !selected, hasChildren); }}
                                            control={
                                                <Checkbox
                                                    checked={selected}
                                                    disabled={!item.active}
                                                />
                                            }
                                        />
                                        {item.children.map((childItem) =>
                                            <PageNavMenuItemTreeCheckBoxChild
                                                key={childItem.id}
                                                isActive={true}
                                                item={childItem}
                                                level={1}
                                                activeItemIds={props.activeItemIds}
                                                onToggleItem={this.handleToggleItem}
                                            />
                                        )}
                                    </div>;
                                })}
                            </Stack>
                        }
                    </AccordionDetails>
                </Accordion>
                {!props.isActive && (
                    <Stack sx={{ margin: ".5rem" }}>
                        {items.filter(x => props.activeItemIds.includes(x.id) || x.children.some(i => props.activeItemIds.includes(i.id))).map((item) => (
                            <div key={item.id}>
                                <Typography>
                                    {item.title}
                                </Typography>
                                {item.children.map((childItem) =>
                                    <PageNavMenuItemTreeCheckBoxChild
                                        key={childItem.id}
                                        isActive={false}
                                        item={childItem}
                                        level={1}
                                        activeItemIds={props.activeItemIds}
                                        onToggleItem={this.handleToggleItem}
                                    />
                                )}
                            </div>
                        ))}
                    </Stack>
                )}
            </>
        );
    }
}